import React, { useRef, useState } from 'react';
import { Stack, TextField } from '@origin-digital/ods-core';
import { IOriginAddressInternet } from '../AddressManualEntry';
import { AddressMeterSearch } from './AddressMeterSearch';
import { useAddressSearch } from './useAddressSearch';

export interface ILOCSearch {
  endpoint: string;
  onConfirm: (address: IOriginAddressInternet) => void;
}

export const AddressLOCSearch: React.FC<ILOCSearch> = ({ endpoint, onConfirm }) => {
  const {
    data,
    inputError,
    error,
    isSearching,
    isConfirmEnabled,
    validate,
    search: searchAddress,
    resetSearch,
    config,
  } = useAddressSearch(endpoint, 'LOC_OPC');

  const [value, setValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Stack space="large">
      <TextField
        inputRef={inputRef}
        id="loc-search"
        label={config.label}
        error={!!inputError}
        value={value}
        helperText={inputError}
        onBlur={({ target }) => validate(target.value)}
        onChange={({ target }) => setValue(target.value)}
        maxLength={config.maxLength}
        hideHelperTextSpace={!!error || isConfirmEnabled}
        endIcon={data && 'success'}
      />
      <AddressMeterSearch
        addressResult={data as IOriginAddressInternet}
        error={error}
        inputRef={inputRef}
        isConfirmEnabled={isConfirmEnabled}
        isLoading={isSearching}
        meterType="LOCid/OPCid"
        onConfirm={onConfirm}
        onResetSearch={resetSearch}
        onSearch={() => searchAddress(value)}
      />
    </Stack>
  );
};
